import MuiLogoutIcon from '@mui/icons-material/Logout';

export const LogoutIcon = ({ className }: { className: string }) => (
    <MuiLogoutIcon className={className} />
);
